import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import rootReducer from "./reducers";
import rootSaga from "./sagas";
import baseApi from "./api/baseApi";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // localStorage
// Create saga middleware
const sagaMiddleware = createSagaMiddleware();

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "user"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure store with RTK
const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      thunk: true, // disable thunk since you use sagas
      serializableCheck: false, // optional: skip serializable warnings
    })
      .concat(sagaMiddleware)
      .concat(baseApi.middleware),
  devTools: process.env.NODE_ENV !== "production", // Enable Redux DevTools only in dev
});

// Run sagas
sagaMiddleware.run(rootSaga);

export default store;
